import {
  GET_COMPANY_MANAGERS,
  GET_COMPANY_MANAGERS_ERROR,
  GET_COMPANY_MANAGERS_SUCCESS
} from './CompanyAdministrationSection.actions'

const companyAdministrationState = {
  error: undefined,
  loading: true,
  managers: [],
  source: 'affidavit'
}

/**
 * The Company Administration Section reducer.
 */
const companyAdministrationReducer = (state = companyAdministrationState, { payload, type }) => {
  switch (type) {
    case GET_COMPANY_MANAGERS: {
      return { ...state, loading: true }
    }
    case GET_COMPANY_MANAGERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        managers: payload.managers,
        source: payload.source,
        error: false
      }
    }
    case GET_COMPANY_MANAGERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: state.managers.length > 0 ? false : payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default companyAdministrationReducer
